import { CalendarCheckIcon, CalendarXIcon } from '@phosphor-icons/react'
import { PasteClipboard } from 'iconoir-react'
import type { ReactElement } from 'react'
import type { ContactCardFacts } from 'app/components/lists/card/contactCardFacts'
import { CardChip } from 'app/components/lists/card/sections/CardChip'
import { Badge } from 'app/components/ui/badge'
import { TASK_BADGE_COLOR } from 'app/lib/taskBadges'

/** A booking or a broken one, and the most urgent open task. */
export function ChipsSection({ derived }: { derived: ContactCardFacts }): ReactElement | null {
  const { appointmentWorthSaying, taskBadge, facts } = derived
  if (!(appointmentWorthSaying || taskBadge)) return null
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
      {appointmentWorthSaying && (
        <CardChip
          tone={facts.appointment.tone}
          icon={
            facts.appointment.tone === `green` ? (
              <CalendarCheckIcon size={12} weight="bold" />
            ) : (
              <CalendarXIcon size={12} weight="bold" />
            )
          }
        >
          {facts.appointment.label}
        </CardChip>
      )}
      {taskBadge && (
        <span title={taskBadge.tooltip}>
          <Badge
            color={TASK_BADGE_COLOR[taskBadge.status]}
            label={taskBadge.text}
            icon={<PasteClipboard className="h-3 w-3" strokeWidth={2} />}
          />
        </span>
      )}
    </div>
  )
}
